import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "MDX Components"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "mdx-components"
    }}>{`MDX Components`}</h1>
    <p>{`To provide custom components to MDX context, but still apply styles from your theme, pass an object of custom components to the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` component.
For a list of keys that can be used in the `}<inlineCode parentName="p">{`components`}</inlineCode>{` object, see the `}<a parentName="p" {...{
        "href": "https://mdxjs.com/getting-started/#table-of-components"
      }}>{`MDX docs for components`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { ThemeProvider } from 'theme-ui'
import theme from './theme'
import components from './components'

export default (props) => (
  <ThemeProvider theme={theme} components={components}>
    {props.children}
  </ThemeProvider>
)
`}</code></pre>
    <Note mdxType="Note">
      <p>{`If you do not need to reuse theme styles in your application, the official `}<a parentName="p" {...{
          "href": "https://mdxjs.com/advanced/components#mdxprovider"
        }}><inlineCode parentName="a">{`MDXProvider`}</inlineCode></a>{` component can be used instead.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      